export enum AccountancyValidationStatus {
    Exception = 'Exception',

    /* warnings */
    FieldContentTooLong256 = 'FieldContentTooLong256',
    DocumentHasTooLongNumeration = 'DocumentHasTooLongNumeration',
    SelectedPeriodContainsDocumentsWithAnKsefImportedXml = 'SelectedPeriodContainsDocumentsWithAnKsefImportedXml',
    KsefDocumentsNotSentOrFailed = 'KsefDocumentsNotSentOrFailed',

    /* errors */
    EmptyCollection = 'EmptyCollection',
    TaxOfficeNotSet = 'TaxOfficeNotSet',
    StreetNameTooLong = 'StreetNameTooLong',
    BuildingNumberTooLong = 'BuildingNumberTooLong',
    BuildingNumberTooLong19 = 'BuildingNumberTooLong19',
    BuildingNumberTooShort = 'BuildingNumberTooShort',
    ZipCodeTooLong = 'ZipCodeTooLong',
    ZipCodeTooLong18 = 'ZipCodeTooLong18',
    InvalidCountryCode = 'InvalidCountryCode',
    InvalidCurrencySymbol = 'InvalidCurrencySymbol',
    InvalidSchema = 'InvalidSchema',
    PurchaseContractorTINNotSet = 'PurchaseContractorTINNotSet',
    CompanyKindNotSetInConfiguration = 'CompanyKindNotSetInConfiguration',
    DocumentCannotBeExchangedByEPP = 'DocumentCannotBeExchangedByEPP',
    CouldntSendDocuments = 'CouldntSendDocuments',
    CouldntSaveSentDocumentsStatuses = 'CouldntSaveSentDocumentsStatuses',
    CouldntSaveSentDocumentsStatusesAfterException = 'CouldntSaveSentDocumentsStatusesAfterException',
    ReceiverNotFoundException = 'ReceiverNotFoundException',
    NoDocumentsSelected = 'NoDocumentsSelected'
}
